import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { getTheme } from '../../reducers/theme'

const styles = () => {
  return {
    inputContainer: {
      boxShadow: '0 3px 3px #D2D2D2',
      borderRadius: '50px',
      border: '0',
      height: '40px',
      position: 'relative',
      backgroundColor: 'white',
    },
    input: {
      border: '0',
      boxSizing: 'border-box',
      width: 'calc(100% - 30px)',
      outline: 0,
      left: '20px',
      right: '20px',
      top: '5px',
      bottom: '5px',
      position: 'absolute',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    theme: getTheme(state),
  }
}

@connect(mapStateToProps)
@injectSheet(styles)
class TextInput extends Component {
  static defaultProps = {
    type: 'text',
  }

  handleTextChange = (event) => {
    const { onChange } = this.props
    if (onChange) {
      onChange(event.target.value)
    }
  }

  render() {
    const {
      classes, placeholder, value, type,
    } = this.props
    return (
      <div className={classes.inputContainer}>
        <input
          className={classes.input}
          placeholder={placeholder}
          onChange={this.handleTextChange}
          type={type}
          value={value}
        />
      </div>
    )
  }
}

TextInput.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default TextInput
